import React from 'react';

import { Link } from 'gatsby';

import CDNImage from '../cdn-image';

import '../../../styles/common/promos/new-prints-banner.scss';

const NewPrintsBanner = (props) => (
	<>
		{(props.path.substr(0, 5) !== '/shop' &&
	      props.path.substr(0, 8) !== '/product') && (
			
			<div role="complementary" aria-label="Promotional Banner" className="sitewide-banner new-prints-banner">
				<Link to="/shop/fine-art-prints">
					<div className="contents page-width">
						<span className="left-side">
							<div className="images">
								<div>
									<CDNImage
										imagePath="/banners/new-prints/nov-2023-prints-00001.jpg"
										height="360"
										alt="Ancient manuscript artwork showing a large, colorful bird with spread wings perched on an ornate stand, with a small figure collecting drops from its beak."
									/>
								</div>
								<div>
									<CDNImage
										imagePath="/banners/new-prints/nov-2023-prints-00038.jpg"
										height="360"
										alt="Engraving of a woman adorned with flowers contrasted with a skeletal half"
									/>
								</div>
							</div>
						</span>
						<span className="details">
							<span className="headline">
								54 new prints just added to our online shop
							</span>
							
							<span className="cta-button">
								Explore Our Prints
							</span>
							
							<span className="footer">
								And now with <i>Free Shipping</i>!
							</span>
						</span>
						<span className="right-side">
							<div className="images">
								<div>
									<CDNImage
										imagePath="/banners/new-prints/nov-2023-prints-00009.jpg"
										height="360"
										alt="Antique Japanese woodblock print featuring multiple rows of stylized Sumo wrestler figures, each depicted in a distinct, colorful attire"
									/>
								</div>
								<div>
									<CDNImage
										imagePath="/banners/new-prints/nov-2023-prints-00017.jpg"
										height="360"
										alt="Colored engraving of a squirrel amid foliage"
									/>
								</div>
							</div>
						</span>
					</div>
				</Link>
			</div>
	  	)}
	</>
);

export default NewPrintsBanner;